export default __webpack_public_path__ + "static/media/close.2ec54bf9.svg";